export interface ViewerStylingModel {
  logo?: string | null;
  primaryColor?: string;
}
